import React from "react";

export default function BsLink45Deg() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m7.072 9.895-2.058 2.058a4.5 4.5 0 0 0 6.365 6.364l2.742-2.743a4.5 4.5 0 0 0-1.242-7.242l-.88.879c-.088.09-.166.19-.23.299a3 3 0 0 1 1.291 5.005l-2.74 2.742a3.001 3.001 0 1 1-4.245-4.245l1.19-1.188a6.027 6.027 0 0 1-.193-1.93v.001Z"
        fill="#currentColor"
      />
      <path
        d="M9.879 7.091a4.5 4.5 0 0 0 1.242 7.242l1.162-1.164A3 3 0 0 1 10.94 8.15l2.74-2.742a3.002 3.002 0 0 1 4.246 4.245l-1.19 1.188c.168.63.233 1.283.192 1.93l2.058-2.057a4.5 4.5 0 1 0-6.364-6.365L9.879 7.091Z"
        fill="#currentColor"
      />
    </svg>
  );
}
